import { on } from "@ngrx/store";
import { ContractAdminState } from "../contract-admin.state";
import { ContractReportsActions } from "./contract-reports.actions";
import { PagesStore } from "../../../pages.state";

// **************************************************************************
// HELPER: Update contractAdmin state within PagesStore
// **************************************************************************

function withContractAdmin(state: PagesStore, updater: (contractAdmin: ContractAdminState) => ContractAdminState): PagesStore {
    return { ...state, contractAdmin: updater(state.contractAdmin) };
}

// **************************************************************************
// CONTRACT REPORTS REDUCER (array format for PagesStore)
// **************************************************************************

const generateContractReport = on(ContractReportsActions.generateContractReport, (state: PagesStore) => withContractAdmin(state, contractAdminState => ({
    ...contractAdminState,
    contractReports: { ...contractAdminState.contractReports, loading: true, error: null },
})));

const generateContractReportSuccess = on(ContractReportsActions.generateContractReportSuccess, (state: PagesStore, { response }) => withContractAdmin(state, contractAdminState => ({
    ...contractAdminState,
    contractReports: { ...contractAdminState.contractReports, report: response, loading: false },
})));

const generateContractReportFailure = on(ContractReportsActions.generateContractReportFailure, (state: PagesStore, { error }) => withContractAdmin(state, contractAdminState => ({
    ...contractAdminState,
    contractReports: { ...contractAdminState.contractReports, loading: false, error },
})));

const clearContractReport = on(ContractReportsActions.clearContractReport, (state: PagesStore) => withContractAdmin(state, contractAdminState => ({
    ...contractAdminState,
    contractReports: {
        ...contractAdminState.contractReports,
        report: null,
        error: null,
    },
})));

export const contractReportsReducer = [
    generateContractReport,
    generateContractReportSuccess,
    generateContractReportFailure,
    clearContractReport,
];
